module.exports = __webpack_public_path__ + "static/img/AE.1de86517.jpg";